import { render } from "./audiences-sessions.vue?vue&type=template&id=0a13821e"
import script from "./audiences-sessions.vue?vue&type=script&lang=js"
export * from "./audiences-sessions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__